<template>
  <BaseList listSubtitulo="Lista de modelos" :data="dados.results" :columns="columns" :globalFilterFields="columns"
            :totalRecords="dados.count" @update:pagination="loadDataLazy">
    <template v-slot:incluirCadastro>
      <button v-if="isStaff" id="id_incluir" class="btn btn-primary btn-sm font-bold modalIncluir"
              @click="abrirModal('cadastro')"
              title="Incluir novo registro.">
        <i class="fa fa-plus"></i> INCLUIR
      </button>
    </template>

    <template #actions="{ data }">
      <div class="dropdown text-center">
        <button
            class="btn btn-info btn-sm dropdown-toggle font-bold"
            type="button"
            data-toggle="dropdown" data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
        >
          OPÇÕES
        </button>
        <ul class="dropdown-menu p-2 border-0 shadow-sm rounded-3">
          <li>
            <button class="btn btn-outline-success font-bold mb-1 w-100 rounded etapa_modelo" :data-id="data.id" :data-desc="data.descricao">
              <i class="fa fa-list"></i> ETAPA MODELO
            </button>
          </li>
          <li>
            <button class="btn btn-outline-primary font-bold mb-1 w-100 rounded" @click="abrirModal('tabs', 'info', data.id, data.key)">
              <i class="fa fa-eye"></i> Visualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-custom-orange font-bold mb-1 w-100 rounded" @click="abrirModal('tabs', 'editar', data.id, data.key)">
              <i class="fa fa-edit"></i> Atualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-danger font-bold mb-1 w-100 rounded" @click="deletarItem(data.key, data.id, data.descricao)">
              <i class="fa fa-trash"></i> Excluir
            </button>
          </li>
        </ul>
      </div>
    </template>
  </BaseList>
  <CadastrarModelos
      v-if="modalAtivo === 'cadastro'"
      :idModal="'cadastarModelo'"
      @fechar="fecharModal"
      @atualizarLista="atualizarListaDados"
  />
  <TabsModalModelo
      v-if="modalAtivo === 'tabs'"
      :idModal="'TabsModal'"
      :itemKey="itemKeySelect"
      :tabSelect="tabSelect"
      @fechar="fecharModal"
      @atualizarDados="atualizarDados"

  />
</template>

<script>
import BaseList from "@/components/base/BaseList.vue";
import CadastrarModelos from "./CadastrarModelos.vue";
import TabsModalModelo from "./TabsModalModelo.vue";
import {apiRequest, alertDelete} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";

export default {
  name: "ListaModelos",
  components: {
    BaseList,
    CadastrarModelos,
    TabsModalModelo,
  },
  emits: ["atualizarDados"],
  data() {
    return {
      dados: {
        results: [],
        count: 0,
      },
      pagination: {
        page: 1,
        page_size: 10,
      },
      erro: null,
      modalAtivo: null,
      itemSelect: null,
      itemKeySelect: null,
      tabSelect: 'editar',
      isStaff: localStorage.getItem('admin_isStaff'),
      columns: [
        {field: 'id', header: 'ID', align: 'text-right',},
        {field: 'descricao', header: 'DESCRIÇÃO',},
        {field: 'descritivo', header: 'DESCRITIVO',},
        {field: 'orcamento', header: 'ORÇAMENTO(R$)', align: 'text-right',},
      ]
    };
  },
  methods: {
    atualizarListaDados(novoDado) {
      this.loadDataLazy({page: 1, page_size: this.pagination.page_size});
    },
    atualizarDados(dadoAtualizado) {
      const index = this.dados.results.findIndex(dado => dado.id === dadoAtualizado.id);
      if (index !== -1) {
        this.dados.results[index] = dadoAtualizado;
      }
    },
    abrirModal(tipo, modal = null, id = null, key = null) {
      this.modalAtivo = tipo;
      this.tabSelect = modal
      if (key) {
        this.itemKeySelect = key;
      }
      if (id) {
        this.itemSelect = id;
      }
    },
    fecharModal() {
      this.modalAtivo = null;
    },
    deletarItem(itemkey, itemId, itemNome) {
      let url = apiUrl.modelos.retrieveUpdateDestroy(itemkey);
      alertDelete(itemkey, url, 'Você deseja deletar o registro?', `ID: ${itemId} | ${itemNome}`, () => {
        this.loadDataLazy(this.pagination);
      });
    },
    async loadDataLazy(paginationParams = this.pagination) {
      this.pagination = {
        page: paginationParams.page,
        page_size: paginationParams.page_size,
      };

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
      };

      if (paginationParams.search) {
        params.search = paginationParams.search;
      }

      const resultado = await apiRequest("GET", apiUrl.modelos.createList, params);

      if (resultado.success) {
        this.dados.results = resultado.data.results || [];
        this.dados.count = resultado.data.count || 0;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      await this.loadDataLazy();
    },
  },
  mounted() {
    this.getDados();
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.etapa_modelo');
      if (button) {
        const modeloId = button.getAttribute('data-id');
        const modeloDesc = button.getAttribute('data-desc');

        this.$router.push({name: 'modelo_etapas', query: {modeloId, modeloDesc}});
      }
    })
  },
};
</script>
